import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export const Item = ({
  id,
  value,
  style,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: id });
  let default_style = {
    transform: CSS.Transform.toString(transform),
    transition,
    display: 'inline-block',
    minWidth: '25px',
    minHeight: '25px',
    zIndex: isDragging ? 300 : 'unset'
  };

  if (style && typeof style === 'object') {
    default_style = {
      ...default_style,
      ...style
    }
  }
  return (
    <div
    ref = { setNodeRef }
    style = { default_style }
    {...attributes}
    {...listeners}
    >
      {
        value
      }
    </div>
  );
};